import angular from 'angular';

class SearchbarController {
  /* @ngInject */
  constructor($timeout) {
    const that = this;
    const minLengthForSearch = isNaN(that.minLengthForSearch) ? 3 : that.minLengthForSearch;
    let timeout;
    let text;

    const callback = () => {
      if (that.searchTerms) {
        that.searchTerms = text.length > 0 ? text.split(' ') : [];
      }

      if (angular.isFunction(that.onSearch)) {
        that.onSearch();
      }
    };

    const cancelTimeout = () => {
      if (timeout) {
        $timeout.cancel(timeout);
        timeout = undefined;
      }
    };

    const init = () => {
      that.text = '';
      that.searchText = '';

      if (that.searchTerms) {
        that.searchTerms = [];
      }
    };

    that.$onInit = init;

    that.doSearch = (skipTimeout) => {
      if (skipTimeout) {
        cancelTimeout();
        text = that.searchText.trim();
        callback();
      } else {
        const trimmedText = that.searchText.trim();
        if (trimmedText === '' || trimmedText.length >= minLengthForSearch) {
          cancelTimeout();
          text = trimmedText;
          timeout = $timeout(callback, 1000);
        }
      }
    };
  }
}

export default SearchbarController;



/** WEBPACK FOOTER **
 ** ./client/app/common/components/searchbar/searchbar.controller.js
 **/